import { CheckCircle2, Clock, UserCheck, Stethoscope, CalendarClock, XCircle } from "lucide-react";

const STATUS_CONFIG = {
  SCHEDULED: { label: "Scheduled", cls: "bg-slate-100 text-slate-700", icon: Clock },
  WAITING: { label: "Waiting", cls: "bg-amber-50 text-amber-700", icon: UserCheck },
  WITH_DOCTOR: { label: "With Doctor", cls: "bg-teal-50 text-teal-700", icon: Stethoscope },
  COMPLETED: { label: "Completed", cls: "bg-green-50 text-green-700", icon: CheckCircle2 },
  FOLLOW_UP_SCHEDULED: { label: "Follow-up Scheduled", cls: "bg-blue-50 text-blue-700", icon: CalendarClock },
  CANCELLED: { label: "Cancelled", cls: "bg-red-50 text-red-700", icon: XCircle },
};

export function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.SCHEDULED;
  const Icon = config.icon;
  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase()}`}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${config.cls}`}
    >
      <Icon className="h-3 w-3" />
      {config.label}
    </span>
  );
}

export function TypeBadge({ type }) {
  const map = {
    NEW_VISIT: "bg-slate-100 text-slate-700",
    FOLLOW_UP: "bg-blue-50 text-blue-700",
    EMERGENCY: "bg-red-50 text-red-700 font-semibold",
  };
  const label = { NEW_VISIT: "New Visit", FOLLOW_UP: "Follow-up", EMERGENCY: "Emergency" }[type] || type;
  return (
    <span
      data-testid={`type-badge-${type?.toLowerCase()}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${map[type] || "bg-slate-100 text-slate-700"}`}
    >
      {label}
    </span>
  );
}
